import { jsx, jsxs } from "react/jsx-runtime";
import CheckmarkCircle from "@crehana/compass.icons.fill/CheckmarkCircle";
import CloseCircle from "@crehana/compass.icons.fill/CloseCircle";
import compass_icons_outline_CheckmarkCircle from "@crehana/compass.icons.outline/CheckmarkCircle";
import { clsx } from "clsx";
const RULE_ICON = {
    pending: {
        Icon: compass_icons_outline_CheckmarkCircle,
        className: 'tw-cds-text-secondary'
    },
    met: {
        Icon: CheckmarkCircle,
        className: 'tw-cds-text-success'
    },
    failed: {
        Icon: CloseCircle,
        className: 'tw-cds-text-alert'
    }
};
const getRuleState = (rule, password)=>{
    if ('' === password) return 'pending';
    try {
        return new RegExp(rule.regex).test(password) ? 'met' : 'failed';
    } catch  {
        return 'failed';
    }
};
const PasswordRulesList = ({ rules, password, title })=>{
    if (0 === rules.length) return null;
    return /*#__PURE__*/ jsxs("div", {
        className: "tw-flex tw-flex-col tw-gap-0.8 tw-mt-1.2 tw-border tw-border-solid tw-cds-border-default tw-cds-rounded-s tw-cds-bg-layer-02 tw-cds-p-4",
        children: [
            /*#__PURE__*/ jsx("p", {
                className: "tw-cds-font-label-01 tw-cds-text-secondary tw-uppercase tw-mb-0.4",
                children: title
            }),
            rules.map((rule)=>{
                const state = getRuleState(rule, password);
                const { Icon, className } = RULE_ICON[state];
                return /*#__PURE__*/ jsxs("div", {
                    className: "tw-flex tw-items-center tw-gap-0.8",
                    children: [
                        /*#__PURE__*/ jsx(Icon, {
                            size: 16,
                            className: className
                        }),
                        /*#__PURE__*/ jsx("span", {
                            className: clsx(className, 'tw-cds-font-body-01'),
                            children: rule.description
                        })
                    ]
                }, rule.id);
            })
        ]
    });
};
export { PasswordRulesList };
